module.exports = __webpack_public_path__ + "assets/img/trust_11.7a824f3f.png";